export const savedLocationKeys = {
    all: ['saved-locations'] as const,
    lists: (customerId: string) => [...savedLocationKeys.all, customerId, 'list'] as const,
    list: (customerId: string, filters: Record<string, unknown> = {}) =>
        [...savedLocationKeys.lists(customerId), filters] as const,
}
